import type { ButtonHTMLAttributes } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'accent';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  block?: boolean;
}

export function Button({
  variant = 'primary',
  block,
  className = '',
  type = 'button',
  children,
  ...rest
}: ButtonProps): JSX.Element {
  return (
    <button
      type={type}
      className={`ma-btn ${
        variant === 'primary'
          ? 'ma-btn-primary'
          : variant === 'secondary'
            ? 'ma-btn-secondary'
            : variant === 'ghost'
              ? 'ma-btn-ghost'
              : variant === 'danger'
                ? 'ma-btn-danger'
                : 'ma-btn-accent'
      } ${block ? 'ma-btn-block' : ''} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
